module.exports = __webpack_public_path__ + "img/00043.a0453bc5.webp";